import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiPhone, FiMail, FiMenu, FiChevronDown, FiX } from "react-icons/fi";
import "./Navbar.css";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [productsOpen, setProductsOpen] = useState(false);
    const [clickCount, setClickCount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const logoClickTimeout = useRef(null);

    const toggleMenu = () => setMenuOpen(prev => !prev);
    const toggleProducts = () => setProductsOpen(prev => !prev);
    const closeAll = () => {
        setMenuOpen(false);
        setProductsOpen(false);
    };

    const handleLogoClick = () => {
        setClickCount(prev => {
            const newCount = prev + 1;
            if (newCount >= 3) {
                setShowPopup(true);
                return 0;
            }
            clearTimeout(logoClickTimeout.current);
            logoClickTimeout.current = setTimeout(() => setClickCount(0), 2000); // Reset after 2 sec
            return newCount;
        });
    };

    const closePopup = () => setShowPopup(false);
    const controlList = [
        { name: "Support page ->Ctrl + F9", usedIn: "click to quick links" },
        { name: "Industries specific page ->Ctrl + F9", usedIn: "click to quick links" },

    ];

    return (
        <>
            {/* Navbar */}
            <nav className="navbar">
                <div className="navbar-container">
                    {/* Left - Links */}
                    <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
                        <li className="dropdown">
                            <span className="dropdown-toggle" onClick={toggleProducts}>
                                Products <FiChevronDown />
                            </span>
                            {productsOpen && (
                                <ul className="dropdown-menu">
                                    <li><Link to="/Productoverview" onClick={closeAll}>Product Overview</Link></li>
                                    <li><Link to="/whatsnew" onClick={closeAll}>What's New</Link></li>
                                </ul>
                            )}
                        </li>

                        <li><Link to="/Pricing" onClick={closeAll}>Pricing</Link></li>
                        <li><Link to="/Support" onClick={closeAll}>Support</Link></li>
                        <li><Link to="/Features" onClick={closeAll}>Features</Link></li>
                        <li><Link to="/Industrial-specification" onClick={closeAll}>Industrial Specifics</Link></li>

                        {/* Mobile Buttons */}
                        <div className="mobile-buttons">
                            <Link to="/Demo" className="btn" onClick={closeAll}>Get a Demo</Link>
                            <Link to="/Download" className="btn" onClick={closeAll}>Download</Link>
                        </div>
                    </ul>

                    {/* Center - Logo */}
                    <div className="navbar-logo" onClick={handleLogoClick}>
                        <Link to="/"><img src="/images/auditlogo.png" alt="Logo" /></Link>
                    </div>

                    {/* Right - Buttons (desktop only) */}
                    <div className="navbar-buttons">
                        <Link to="/Demo" className="btn">Get a Demo</Link>
                        <Link to="/download" className="btn">Download</Link>
                    </div>

                    {/* Menu icon for mobile */}
                    <div className="navbar-toggle" onClick={toggleMenu}>
                        <FiMenu size={24} />
                    </div>
                </div>
            </nav>

            {/* Popup Modal */}
            {showPopup && (
                <div className="custom-modal-backdrop">
                    <div className="custom-modal">
                        <button className="modal-close" onClick={closePopup}><FiX size={20} /></button>
                        <h3>Auditusierp Mobile Controls</h3>
                        <ul className="control-list">
                            {controlList.map((control, index) => (
                                <li key={index}>
                                    <strong>{control.name}</strong> – {control.usedIn}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;
